import { Button, Col, Modal, ModalBody, Row } from "reactstrap";
import PasswordInput from "../inputs/PasswordInput";
import { useTranslation } from "../../languages";

const ChangePassword = ({
  modalOpen,
  setModalOpen,
  passwords,
  setPasswords,
  onPressSaveBtn,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      toggle={() => setModalOpen((prev) => !prev)}
      size="lg"
      fade={false}
      centered
      isOpen={modalOpen}
    >
      <ModalBody className="bg-white" style={{ borderRadius: "40px" }}>
        <h4 className="mb-4 mt-3 text-center position-relative f-6 figma-shadowed-black-text">
          {t("changePassword")}
        </h4>
        <Row className="justify-content-center gy-3 mx-0 ">
          <Col md={11} className="p-0">
            <PasswordInput
              label={t("currentPassword")}
              placeholder="Enter your current password"
              value={passwords?.old}
              setValue={(v) => setPasswords((prev) => ({ ...prev, old: v }))}
            />
            <PasswordInput
              label={t("newPassword")}
              placeholder="Enter your new password"
              value={passwords?.new}
              setValue={(v) => setPasswords((prev) => ({ ...prev, new: v }))}
            />
            <PasswordInput
              label={t("confirmPassword")}
              placeholder="Write confirm  password"
              value={passwords?.confirm}
              setValue={(v) =>
                setPasswords((prev) => ({ ...prev, confirm: v }))
              }
            />
          </Col>
        </Row>
        <Row className="justify-content-center g-0 mx-0 mt-5 mb-3">
          <Col md={8}>
            <Button
              onClick={onPressSaveBtn}
              className="standard-rounded-btn full-width btn-lg"
            >
              {t("save")}
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default ChangePassword;
